import { fetchTableRows, apiFetch } from './api';

export function fetchAllActivities() {
	return fetchTableRows( 'activity' );
}

/**
 * Current user's registrations, keyed by activity ID:
 * { [activityId]: { id, statusId, statusName } }. Empty object on failure.
 */
export function fetchMyRegistrations() {
	return apiFetch( '/anacrm/v1/registrations/my' ).catch( () => ( {} ) );
}

/**
 * Attach the user's registration (and a cancel handler) to each activity row.
 *
 * @param {Array}    nodes         Activities from fetchAllActivities().
 * @param {Object}   registrations Map from fetchMyRegistrations().
 * @param {Function} setData       State setter of the table's rows.
 * @return {Array} Rows with `_userRegistration` and `_onCancelRegistration`.
 */
export function withUserRegistrations( nodes, registrations, setData ) {
	return nodes.map( ( node ) => ( {
		...node,
		_userRegistration: registrations[ node.databaseId ] ?? null,
		_onCancelRegistration: async () => {
			const reg = registrations[ node.databaseId ];
			if ( ! reg ) {
				return;
			}
			const updated = await apiFetch(
				`/anacrm/v1/registrations/${ reg.id }`,
				{ method: 'DELETE' }
			);
			setData( ( prev ) =>
				prev.map( ( r ) =>
					r.databaseId === node.databaseId
						? {
								...r,
								_userRegistration: {
									...reg,
									...updated,
								},
						  }
						: r
				)
			);
		},
	} ) );
}
